import { motion } from "framer-motion";
import { CreditCard } from "lucide-react";

export const PayLaterStrip = () => (
  <section className="relative overflow-hidden bg-gradient-to-r from-[#b2fce4]/15 via-dream-violet/20 to-cyan-500/15 border-y border-white/10" data-testid="pay-later-strip">
    <div className="max-w-7xl mx-auto px-6 py-10 md:py-12 grid md:grid-cols-[1fr_auto] items-center gap-8">
      <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#b2fce4] mb-3 flex items-center gap-2">
          <CreditCard className="w-4 h-4" /> Afterpay &amp; Zip Pay · All services
        </p>
        <h2 className="font-display text-2xl sm:text-3xl font-semibold text-white tracking-tight">
          Create today. <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#b2fce4] to-cyan-300">Pay later.</span>
        </h2>
        <p className="text-white/60 text-sm md:text-base mt-2 max-w-xl">Split any booking — studio time, DJ room, courses or press shots — into 4 interest-free payments. Pay 25% today, the rest later. e.g. $400 session = $100 today.</p>
      </motion.div>
      <div className="flex gap-6 md:gap-10">
        {[["4", "Payments"], ["0%", "Interest"], ["25%", "Paid today"]].map(([v, l]) => (
          <div key={l} className="text-center">
            <p className="font-display text-2xl md:text-3xl font-semibold text-white">{v}</p>
            <p className="text-white/50 text-xs uppercase tracking-wider mt-1">{l}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
